import Text from "../atoms/Text";
import MerchantCard from "../molecules/MerchantCard";
import React, { useCallback, useRef, useState } from "react";
import { SwiperSlide } from "swiper/react";
import FourRowCarousel from "../components/common/FourRowCarousel";
import IcomoonIcon from "../atoms/IcomoonIcon";
import { useRouter } from "next/router";

const CategoryInfoCarousel = ({ categoryTitle, merchantCard, swiperRef, ...property }) => {
    const router = useRouter();
    const sliderRef = useRef(null);
    const [isBegin, setIsBegin] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const [slideState, setSlideState] = useState(null);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
        setIsBegin(sliderRef.current.swiper.isBeginning);
        setIsEnd(sliderRef.current.swiper.isEnd);
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
        setIsBegin(sliderRef.current.swiper.isBeginning);
        setIsEnd(sliderRef.current.swiper.isEnd);
    }, []);

    return (
        <div className={`relative w-full pt-6 ${property.className}`}>
            <div className="flex justify-between mb-3">
                <Text variant="large" className="text-neutral-800">
                    {categoryTitle}
                </Text>
                <div className={`flex space-x-2 ml-3 ${merchantCard.length > 4 ? "lg:flex" : "lg:hidden"}`}>
                    {sliderRef?.current?.swiper?.width !== sliderRef?.current?.swiper?.virtualSize && (
                        <div
                            onClick={handlePrev}
                            className={`cursor-pointer flex justify-center items-center rounded-full w-8 h-8 bg-primary-900 ${isBegin ? "bg-opacity-50" : ""}`}
                        >
                            <IcomoonIcon icon={"arrow-right"} className={"rotate-180"} color="white" size="20px" />
                        </div>
                    )}
                    {sliderRef?.current?.swiper?.width !== sliderRef?.current?.swiper?.virtualSize && (
                        <div
                            onClick={handleNext}
                            className={`disabled:opacity-50 cursor-pointer flex justify-center items-center rounded-full w-8 h-8 bg-primary-900 ${isEnd ? "bg-opacity-50" : ""}`}
                        >
                            <IcomoonIcon icon={"arrow-right"} color="white" size="20px" />
                        </div>
                    )}
                </div>
            </div>

            <FourRowCarousel sliderRef={sliderRef} setIsBegin={setIsBegin} setIsEnd={setIsEnd} setSlideState={setSlideState} className="justify-start">
                {merchantCard.map((merchant, index) => (
                    <SwiperSlide
                        className={`flex justify-start items-start p-1 !mr-2`}
                        onClick={() => {
                            router.push(`/merchants/${merchant.name}/${merchant.id}`);
                        }}
                        key={index}
                    >
                        <MerchantCard
                            className="flex-grow"
                            image={merchant.logo}
                            time={"Ends: Ongoing"}
                            cashbackPercentage={`Up to ${merchant.cashback / 100}% cashback`}
                            name={merchant.name}
                        />
                    </SwiperSlide>
                ))}
            </FourRowCarousel>
        </div>
    );
};

export default CategoryInfoCarousel;
